import SingleSearch from 'jsx/components/core/form/components/SingleSearch';
import { noop } from 'lodash';
import { Button, Label } from 'reactstrap';

const GroupsToolbar = ({
  groups = [],
  searchValue = '',
  onChange = noop,
  handleSearchChange = noop,
  setModal = noop,
}) => {
  const count = `${groups.count} groups`;
  return (
    <div className="m-1 d-flex justify-content-end">
      <Label className="m-1 mr-2 text-secondary">{count}</Label>
      <SingleSearch
        handleSearchChange={handleSearchChange}
        placeholder="Filter by keyword"
        value={searchValue}
      />
      <Button onClick={onChange} size="sm" color="success" className="mr-2">
        Go
      </Button>
      <Button onClick={() => setModal(true)} size="sm" color="success">
        Add New Group
      </Button>
    </div>
  );
};

export default GroupsToolbar;
